import { TemplateBuilderWidget } from './template-builder-widget.model';
import { generateShortUuid } from 'ag-common-svc/shared/utils/generate-item-uuid';
import {
  AlignItems,
  VerticalAlignItems,
} from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-align-items.model';

export class TemplateBuilderColumn {
  id: string;
  items: TemplateBuilderWidget[] = [];
  options: ColumnOptions = new ColumnOptions();

  constructor(public ratio: number) {
    this.id = generateShortUuid();
  }
}

export class ColumnOptions {
  horizontalAlignment: AlignItems = AlignItems.flexStart;
  verticalAlignment: VerticalAlignItems = VerticalAlignItems.start;
  backgroundColor: string = 'transparent';
}
